
/* injects from baggage-loader */

'use strict';

import InvestAccreditedController from './invest.accredited.controller';
import InvestAccreditedTemplate from './invest.accredited.html';

export default class InvestAccreditedComponent {
		constructor() {
				this.templateUrl = InvestAccreditedTemplate;
				this.controller = InvestAccreditedController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					project: '<',
					investment: '<',
					investor: '<',
					sidePanelData: '<',
					updateSummaryData: '&',
					investorDocuments: '<',
					accreditation: '<'
				};
		}
}
